module.exports = __webpack_public_path__ + "img/activate.a466f89d.svg";